import { botApi } from './botApi'
interface IConnection {
  _id?: string
  start: number
  isFinished?: boolean
  device: string
  end?: number
  name?: string
}

export const connectionApi = botApi.injectEndpoints({
  endpoints: ({ query }) => ({
    connection: query<IConnection[], { token: string; name: string }>({
      query: ({ token, name }) => `/connections?token=${token}&name=${name}`,
    }),
  }),
})

export const { useConnectionQuery } = connectionApi
